module.exports = __webpack_public_path__ + "static/media/share.22f7cfa1.svg";